export default [
  {
    'id': 1,
  	"title":"Посольство Республики Узбекистан в Украине",
  	"address":null,
  	"reception_days":null,
  	"phone":"(38044) 501-50-00 ",
  	"fax": "(38044) 501-50-01, (38044) 501-41-83",
  	"website":"www.uzbekistan.org.ua ",
  	"email":"embassy@uzbekistan.org.ua ",
  	"latitude":"30.5164339 ",
  	"longitude":"50.4548775 "
  },
  {
    'id': 2,
    "title":"Посольство Республики Узбекистан в Украине",
    "address":null,
    "reception_days":null,
    "phone":"(38044) 501-50-00 ",
    "fax": "(38044) 501-50-01, (38044) 501-41-83",
    "website":"www.uzbekistan.org.ua ",
    "email":"embassy@uzbekistan.org.ua ",
    "latitude":"30.5164339 ",
    "longitude":"50.4548775 "
  },
  {
    'id': 3,
    "title":"Посольство Республики Узбекистан в Украине",
    "address":null,
    "reception_days":null,
    "phone":"(38044) 501-50-00 ",
    "fax": "(38044) 501-50-01, (38044) 501-41-83",
    "website":"www.uzbekistan.org.ua ",
    "email":"embassy@uzbekistan.org.ua ",
    "latitude":"30.5164339 ",
    "longitude":"50.4548775 "
  },
  {
    'id': 4,
    "title":"Посольство Республики Узбекистан в Украине",
    "address":null,
    "reception_days":null,
    "phone":"(38044) 501-50-00 ",
    "fax": "(38044) 501-50-01, (38044) 501-41-83",
    "website":"www.uzbekistan.org.ua ",
    "email":"embassy@uzbekistan.org.ua ",
    "latitude":"30.5164339 ",
    "longitude":"50.4548775 "
  },
  {
    'id': 5,
    "title":"Посольство Республики Узбекистан в Украине",
    "address":null,
    "reception_days":null,
    "phone":"(38044) 501-50-00 ",
    "fax": "(38044) 501-50-01, (38044) 501-41-83",
    "website":"www.uzbekistan.org.ua ",
    "email":"embassy@uzbekistan.org.ua ",
    "latitude":"30.5164339 ",
    "longitude":"50.4548775 "
  },
  {
    'id': 6,
    "title":"Посольство Республики Узбекистан в Украине",
    "address":null,
    "reception_days":null,
    "phone":"(38044) 501-50-00 ",
    "fax": "(38044) 501-50-01, (38044) 501-41-83",
    "website":"www.uzbekistan.org.ua ",
    "email":"embassy@uzbekistan.org.ua ",
    "latitude":"30.5164339 ",
    "longitude":"50.4548775 "
  },
  {
    'id': 7,
    "title":"Посольство Республики Узбекистан в Украине",
    "address":null,
    "reception_days":null,
    "phone":"(38044) 501-50-00 ",
    "fax": "(38044) 501-50-01, (38044) 501-41-83",
    "website":"www.uzbekistan.org.ua ",
    "email":"embassy@uzbekistan.org.ua ",
    "latitude":"30.5164339 ",
    "longitude":"50.4548775 "
  },
  {
    'id': 8,
    "title":"Посольство Республики Узбекистан в Украине",
    "address":null,
    "reception_days":null,
    "phone":"(38044) 501-50-00 ",
    "fax": "(38044) 501-50-01, (38044) 501-41-83",
    "website":"www.uzbekistan.org.ua ",
    "email":"embassy@uzbekistan.org.ua ",
    "latitude":"30.5164339 ",
    "longitude":"50.4548775 "
  },
  {
    'id': 9,
    "title":"Посольство Республики Узбекистан в Украине",
    "address":null,
    "reception_days":null,
    "phone":"(38044) 501-50-00 ",
    "fax": "(38044) 501-50-01, (38044) 501-41-83",
    "website":"www.uzbekistan.org.ua ",
    "email":"embassy@uzbekistan.org.ua ",
    "latitude":"30.5164339 ",
    "longitude":"50.4548775 "
  },
  {
    'id': 10,
    "title":"Посольство Республики Узбекистан в Украине",
    "address":null,
    "reception_days":null,
    "phone":"(38044) 501-50-00 ",
    "fax": "(38044) 501-50-01, (38044) 501-41-83",
    "website":"www.uzbekistan.org.ua ",
    "email":"embassy@uzbekistan.org.ua ",
    "latitude":"30.5164339 ",
    "longitude":"50.4548775 "
  }
];



// WEBPACK FOOTER //
// ./src/apps/consulates/fake-api/data.js